module.exports = {
  QuickSearchAdNumber: 'Быстрый поиск: номер объявления',
  Remove: 'Снять с публикации',
  Publish: 'Опубликовать',
  AdNumber: 'Номер объявления',
  SubjectName: 'Тема/Название',
  AdContent: 'Содержание объявления',
  Advertiser: 'Рекламодатель',
  AdPosition: 'Рекламное место',
  BelongToPage: 'Принадлежащая страница',
  BelongToModule: 'Принадлежащий модуль',
  BelongToSystem: 'Принадлежащая система',
  Status: 'Статус',
  TargetAudience: 'Целевая аудитория',
  Global: 'Глобально',
  Creator: 'Создатель',
  CreationDate: 'Дата создания',
  Modifier: 'Редактор',
  ModificationDate: 'Дата изменения',
  PromotionPeriod: 'Период продвижения',
  EffectiveTime: 'Время вступления в силу',
  ExpirationTime: 'Время истечения срока',
  PleaseCheckOneEntry: 'Пожалуйста, выберите одну запись!',
  ContainsUnremovedData: 'Содержит данные, не снятые с публикации!',
  AreYouWantToDelete: 'Вы уверены, что хотите удалить?',
  PleaseSelectOneEntry: 'Пожалуйста, выберите одну запись!',
  PleaseOnlySelectOneRecord: 'Пожалуйста, выберите только одну запись!',
  ContainsAlreadyRemovedData: 'Содержит данные, уже снятые с публикации!',
  AreYouWantToRemove: 'Вы уверены, что хотите снять с публикации?',
  AreYouWantToPublish: 'Вы уверены, что хотите опубликовать?',
  ThePositionHasBeenDisabled: 'Это рекламное место отключено!',
  TheReachedTheMaximumPlacements: 'Достигнуто максимальное количество объявлений для этого места!',
  RemainingAreNotEnoughCheck: 'Недостаточно свободных рекламных мест, пожалуйста, проверьте!',
  ContainsPublishedOrExpiredData: 'Содержит уже опубликованные или недействительные данные!',
  View: 'Просмотреть',
  Edit: 'Редактировать',
  Enable: 'Включить',
  Disable: 'Отключить',
  AdPositionNumber: 'Номер рекламного места',
  CurrentlyPlacedAdCount: 'Количество размещённых объявлений',
  MaximumSupportedAdCount: 'Максимальное поддерживаемое количество объявлений',
  CurrentDisabledAndCannotEdited: 'Текущие данные не отключены, редактирование невозможно!',
  AreYouWantToDisable: 'Вы уверены, что хотите отключить?',
  AreYouWantToDisable2: 'Вы уверены, что хотите отключить?',
  ContainsNonDisabledData: 'Содержит данные, которые не отключены!',
  AreYouWantToEnable: 'Вы уверены, что хотите включить?',
  TemplateManagement: 'Управление шаблонами',
  TemplateTypeManagement: 'Управление типами шаблонов',
  ConfigurationManagement: 'Управление конфигурацией',
  MappingManagement: 'Управление отображением',
  InitializeTemplateManagement: 'Управление инициализацией шаблонов',
  BusinessStatusManagement: 'Управление статусом операций',
  TriggerTypeManagement: 'Управление типами триггеров',
  FileTypeManagement: 'Управление типами файлов',
  DefaultValueManagement: 'Управление значениями по умолчанию',
  ValidationRuleConfiguration: 'Настройка правил проверки',
  EDITemplateSetting: 'Настройка шаблонов EDI',
  SeaFreightOnlineCheckingSettings: 'Настройка онлайн-сверки морских перевозок',
  ShippingRouteAndWarehouseConfiguration: 'Конфигурация маршрутов и складов',
  PushServiceConfiguration: 'Настройка сервиса push-уведомлений',
  InvoiceCustomRemark: 'Пользовательские заметки для счетов',
  CustomRemarkOne: 'Пользовательская заметка 1',
  CustomRemarkTwo: 'Пользовательская заметка 2',
  EmailTemplateManagement: 'Управление шаблонами электронной почты',
  ReleaseConfiguration: 'Настройка выпуска документов',
  PromotionTimeRange: 'Период продвижения',
  JumpLink: 'Переход по ссылке',
  Cancel: 'Отмена',
  Save: 'Сохранить',
  Return: 'Назад',
  Homepage: 'Главная страница',
  SelectAll: 'Выбрать все',
  DeselectAll: 'Снять все выделения',
  AreYouWantToCancel: 'Подтверждаете отмену?',
  NumberOfClickedUsers: 'Количество кликов пользователей',
  BelongToCompany: 'Компания',
  UserType: 'Тип пользователя',
  Username: 'Имя пользователя',
  PlatformCustomerService: 'Служба поддержки платформы',
  ClickTime: 'Время клика',
  BrowsingTime: 'Время просмотра',
  StartTime: 'Время начала:',
  EndTime: 'Время окончания:',
  SequenceNumber: 'Порядковый номер',
  Code: 'Код',
  ChineseName: 'Название на китайском',
  EnglishName: 'Название на английском',
  NodeType: 'Тип узла',
  Remarks: 'Примечание',
  CreateStatus: 'Новый статус',
  Delete: 'Удалить',
  IsItPublic: 'Публичный доступ',
  CreateStatusDetail: 'Детали нового статуса',
  EditStatus: 'Редактировать статус',
  DeleteSuccessful: 'Успешно удалено',
  SaveSuccessful: 'Успешно сохранено',
  PleaseEnterCode: 'Введите код',
  PleaseEnterNodeType: 'Введите тип узла',
  PleaseEnterCodeChineseName: 'Введите название кода на китайском',
  PleaseEnterCodeEnglishName: 'Введите название кода на английском',
  StatusType: 'Тип статуса',
  ExternalCode: 'Внешний код',
  Name: 'Название',
  GenerateElectronicFile: 'Создание электронного документа',
  FileType: 'Тип файла',
  DataService: 'Сервис данных',
  ReportTemplate: 'Шаблон отчёта',
  PushObject: 'Объект рассылки',
  PushChannel: 'Канал рассылки',
  SubjectTemplate: 'Шаблон темы',
  BodyTemplate: 'Шаблон текста',
  DataItem: 'Элемент данных',
  AttachmentFileType: 'Тип вложенного файла',
  TemplateSubject: 'Тема шаблона',
  TemplateContent: 'Содержание шаблона',
  TemplateExample: 'Пример шаблона',
  SendTest: 'Тестовая отправка',
  ConfigureSOPMessagePush: 'Настройка рассылки SOP-сообщений',
  EditStatusDetail: 'Редактирование деталей статуса',
  InitialStatus: 'Начальный статус',
  AutoTrigger: 'Автоматический триггер',
  StatusChangeNotification: 'Уведомление об изменении статуса',
  SendNotification: 'Отправить уведомление',
  NoNotification: 'Не отправлять уведомление',
  DesignatedPosition: 'Указанная должность',
  Sales: 'Продажи',
  Operation: 'Операции',
  CustomerService: 'Обслуживание клиентов',
  OverseasCustomerService: 'Зарубежное обслуживание клиентов',
  Documentation: 'Документация',
  ShippingLineManager: 'Ответственный за маршрут',
  DesignatedPersonnel: 'Указанное лицо',
  Email: 'Электронная почта',
  SopPushLog: 'Журнал рассылки SOP',
  Confirm: 'Подтвердить',
  SendTo: 'Отправить:',
  Note: 'Внимание',
  WillBusinessDetailsAndNodes: 'Будут удалены связанные бизнес-детали и узлы SOP',
  PleaseEnterContent: 'Введите содержание',
  NotStarted: 'Не начато',
  InProgress: 'В процессе',
  Completed: 'Завершено',
  Abnormal: 'Исключение',
  BookingSuccessful: 'Успешное бронирование',
  WarehouseEntryNotice: 'Уведомление о размещении на складе',
  CustomsClearance: 'Таможенное оформление',
  SailingNotice: 'Уведомление о выходе в рейс',
  IssuanceOfBillOfLading: 'Выдача коносамента',
  Customer: 'Клиент',
  DestinationPortAgent: 'Агент порта назначения',
  DesignatedFreightForwarder: 'Указанный грузовой агент',
  DeparturePortAgent: 'Агент порта отправления',
  DesignatedPositionsAndPersonnel: 'Назначенная должность и назначенный сотрудник',
  PleaseEnterTheCode: 'Введите код',
  PleaseEnterTheChineseName: 'Введите название на китайском',
  ChineseNameLengthExceeded20: 'Длина названия на китайском превышает 20 символов!',
  PleaseEnterTheEnglishName: 'Введите название на английском',
  PleaseSelectTheStatusType: 'Выберите тип статуса!',
  PleaseSelectTheTriggerType: 'Выберите тип триггера',
  PleaseSelectTheStatusType2: 'Выберите тип статуса',
  TheAlreadyExistsPleaseEnter: 'Такой код уже существует, введите заново!',
  TheAlreadyExistsPleaseEnter2: 'Такое название на китайском уже существует, введите заново!',
  TheAlreadyExistsPleaseEnter3: 'Такое название на английском уже существует, введите заново!',
  SaveSuccess: 'Сохранено успешно',
  DeleteSuccess: 'Удалено успешно',
  BusinessDetailsDoNotExist: 'Детали операции не существуют',
  PleaseEnterTheSubjectTemplate: 'Введите шаблон темы',
  PleaseTheTextTemplateContent: 'Введите содержание шаблона текста',
  PleaseEnterTheTemplateContent: 'Введите содержание шаблона',
  PleaseEnterTheTemplateExample: 'Введите пример шаблона',
  PleaseFirstSelectData: 'Сначала выберите данные',
  AreWantToDeleteRecord: 'Подтверждаете удаление выбранных записей?',
  Tips: 'Подсказка',
  PleaseTheTestEmailAddress: 'Введите тестовый email!',
  EmailFormatError: 'Неверный формат email!',
  EmailCannotExceed128Characters: 'Длина email не должна превышать 128 символов',
  PleaseTestMobilePhoneNumber: 'Введите тестовый номер телефона!',
  MobileCanOnlyBeNumbers: 'Номер телефона должен содержать только цифры!',
  MobilePhoneNumberFormatError: 'Неверный формат номера телефона!',
  SendSuccess: 'Отправлено успешно!',
  SendFailure: 'Ошибка отправки!',
  APIOutputAdditionalInformation: 'Дополнительная информация вывода API',
  OutputDescription: 'Описание вывода',
  OutputIdentification: 'Идентификатор вывода',
  DataSource: 'Источник данных',
  DataField: 'Поля данных',
  WarningSwitch: 'Переключатель оповещения',
  SailingTimeETD: 'Время отплытия (ETD)',
  ArrivalTimeETA: 'Время прибытия в порт (ETA)',
  OpenPortTime: 'Время открытия порта',
  ClosingPortTime: 'Время закрытия порта',
  ClosingTimeForOrders: 'Время закрытия приема заявок',
  CustomsClosingTime: 'Время закрытия таможни',
  ScheduledBerthingDate: 'Планируемая дата швартовки',
  ScheduledDepartureDate: 'Планируемая дата отплытия',
  WarningTime: 'Время оповещения',
  Advance: 'Заранее',
  Delay: 'Отсрочка',
  WarningSettings: 'Настройки оповещения',
  TurnOnWarning: 'Включить оповещение',
  TurnOffWarning: 'Отключить оповещение',
  HoursWarningReminder: 'часов, напоминание',
  Highest: 'Наивысший',
  High: 'Высокий',
  Medium: 'Средний',
  Low: 'Низкий',
  Relation: 'Отношение',
  FilterValue: 'Значение фильтра',
  ValidationCondition: 'Условия проверки',
  New: 'Создать',
  And: 'И',
  Or: 'Или',
  FilterBasis: 'Основание для фильтрации',
  CurrentlyModeUnableToNew: 'Режим редактирования активен, создание невозможно',
  CurrentlyModeUnableToDelete: 'Режим редактирования активен, удаление невозможно',
  PleaseSelectAFilterBasis: 'Выберите основание для фильтрации',
  PleaseSelectTheFilterValue: 'Выберите значение фильтра',
  ValidationExpression: 'Выражение проверки',
  PositiveOperation: 'Прямое действие',
  PreSubmit: 'Предварительная отправка',
  Submitted: 'Отправлено',
  Reviewed: 'Проверено',
  ValidationItem: 'Проверяемый объект',
  Empty: 'Пусто',
  PleaseSelectValidationItem: 'Выберите проверяемый объект',
  RuleName: 'Назв.пр.',
  ValidationNode: 'Узел проверки',
  ValidationType: 'Тип проверки',
  ValidationMode: 'Режим проверки',
  EmailAddress: 'Адрес электронной почты',
  Add: 'Добавить',
  Refresh: 'Обновить',
  ValidationRules: 'Правила проверки',
  AllowOperationAfterValidationFails: 'Разрешить продолжение операции при неудачной проверке?',
  Yes: 'Да',
  No: 'Нет',
  Company: 'Компания',
  ContinueValidation: 'Продолжить проверку',
  CurrentlyYouSureYouRefresh: 'Режим редактирования активен, подтвердить обновление?',
  FailedToInitializeData: 'Ошибка инициализации данных',
  AreRuleAssociatedValidationDeleted: 'Подтверждаете удаление этого правила проверки? Связанные выражения и условия проверки также будут удалены!',
  PleaseSelectTheBranchOffice: 'Выберите филиал',
  PleaseEnterTheRuleName: 'Введите название правила',
  PleaseSelectTheRuleNode: 'Выберите узел правила',
  PleaseSelectTheRuleType: 'Выберите тип правила',
  PleaseSelectTheRuleMode: 'Выберите режим правила',
  CompanyName: 'Название компании',
  PleaseConfigurationNameOrRemarks: 'Введите название конфигурации или примечание',
  Type: 'Тип',
  InterfaceSettings: 'Настройки интерфейса',
  ConfigurationName: 'Название конфигурации',
  DefaultValue: 'Значение по умолчанию',
  EditConfigurationItem: 'Редактировать элемент конфигурации',
  EditConfigurationDefinition: 'Редактировать определение конфигурации:',
  Search: 'Поиск',
  ConfigurationItemconfigId: 'Элемент конфигурации (configId)',
  TypedataType: 'Тип данных (dataType)',
  InterfaceSettingsisClient: 'Настройки интерфейса (isClient)',
  BranchOfficeOptionisOfficeOption: 'Опция филиала (isOfficeOption)',
  ServiceSettingsisServer: 'Настройки сервера (isServer)',
  OptionalItemliterals: 'Опции (literals)',
  ConfigurationNamename: 'Название конфигурации (name)',
  Remarksremarks: 'Примечание (remarks)',
  DefaultValuevalue: 'Значение по умолчанию (value)',
  ConfigurationNameCannotBeEmpty: 'Название конфигурации не может быть пустым',
  DefaultValueCannotBeEmpty: 'Значение по умолчанию не может быть пустым',
  PleaseEnterTheBranchOffice: 'Введите филиал',
  Value: 'Значение',
  ConfigurationItem: 'Элемент конфигурации',
  BranchOffice: 'Филиал',
  PleaseSelectAConfigurationDefinition: 'Выберите определение конфигурации',
  BranchOfficeCannotBeEmpty: 'Филиал не может быть пустым!',
  ValueCannotBeEmpty: 'Значение не может быть пустым!',
  TheConfigurationAlreadyExistsCheck: 'Конфигурация для этого филиала уже существует, проверьте',
  ApplyHeadOfficeSettings: 'Применить настройки головного офиса',
  SleepingDays: 'Дней бездействия',
  SigningDays: 'Дней подписания',
  NotificationObject: 'Получатель уведомления:',
  Supervisor: 'Руководитель',
  NotificationMethod: 'Способ уведомления:',
  InternalReminder: 'Внутреннее уведомление',
  HowDaysBeforeExpirationNotice: 'Уведомить за дней до окончания:',
  Days: 'дней',
  DayMaintenance: 'Обслуживание дней:',
  BusinessEntity: 'Бизнес-сущность',
  SelectEntityConfigurationItem: 'Выбрать элемент конфигурации сущности',
  BranchOffice2: 'Филиал:',
  EntitySelection: 'Выбор сущности:',
  AffiliatedBranchOffice: 'Принадлежащий филиал',
  EntityCode: 'Код сущности',
  EntityName: 'Название сущности',
  FieldCode: 'Код поля',
  FieldName: 'Название поля',
  ValueType: 'Тип значения',
  All: 'Все',
  SelectBranch: 'Выбрать филиал',
  Unused: 'Не используется',
  Used: 'Используется',
  Example8180ThisTicketOnlyDollars: 'Например: USD:355/курс:6.8180/только USD',
  Precautions: 'Примечания:',
  SavedEffectFromTheInvoice: 'Вступает в силу со следующего счета после сохранения',
  EBeLessThanCharacters: 'Примечание к электронному счету должно быть менее 100 символов',
  PaperBeLessThanCharacters: 'Примечание на бумажном билете должно содержать менее 200 символов',
  AutomaticallyALineDoesShow: 'Текст автоматически переносится, если не помещается в одну строку',
  PDFCanDisplayUpLines: 'В PDF-формате счета поле для примечаний отображает не более трёх строк',
  SerialNumber: 'Порядковый номер',
  ExternalFileType: 'Тип внешнего документа',
  NecessaryScenario: 'Обязательный сценарий',
  OriginalScenario: 'Сценарий оригинала',
  TypePermission: 'Права типа',
  AllPositions: 'Все должности',
  Client: 'Доверительная организация',
  Shipper: 'Грузоотправитель',
  Consignee: 'Грузополучатель',
  OverseasAgent: 'Зарубежный агент',
  BookingAgent: 'Агент по бронированию',
  PleaseSelectBookingAgent: 'Выберите агента по бронированию',
  ExternalAccess: 'Внешний доступ',
  B2BCustomer: 'B2B-клиент',
  B2BDesignatedCargoAgent: 'B2B назначенный грузовой агент',
  B2BDestinationPortAgent: 'B2B агент порта назначения',
  B2BConsignee: 'B2B грузополучатель',
  TemplateOutputName: 'Название шаблона для вывода',
  Delimiter: 'Разделитель',
  NoteTemplateNameAccordingNeeds: 'Примечание: задайте название шаблона экспорта по своему усмотрению',
  DefaultSync: 'Синхронизация по умолчанию',
  UsedFileAutomaticallySynchronizesBusiness: 'Настройка автоматической синхронизации данного типа документов между экспортными и импортными операциями',
  CustomTemplateName: 'Пользовательское название шаблона',
  TemplateName: 'Название шаблона',
  Underscore_: 'Подчёркивание _',
  Hyphen: 'Дефис -',
  CreateFileClassification: 'Создать категорию файлов',
  CreateFileType: 'Создать тип файла',
  Create: 'Создать',
  Modify: 'Изменить',
  FileClassification: 'Категория файлов',
  CurrentOperationStatusIsAbnormal: 'Текущее состояние операции некорректно!',
  PleaseSelectChineseName: 'Выберите название на китайском',
  CurrentOperatingStatusAbnormal: 'Текущее состояние операции некорректно',
  CondAlreadyExists: 'Условие уже существует',
  EDIFileDefaultTypeDefaultFileType: 'Тип EDI-документа по умолчанию (DefaultFileType)',
  Emailemail: 'Электронная почта (email)',
  EDIFileEncodingTypeEncodingType: 'Тип кодировки EDI-документа (EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'Способ объединения EDI-документов (FileCombineType)',
  PartnerCodeParnterId: 'Код партнёра (PartnerId)',
  SendFTPFileNamePrefixsendFilePrefix: 'Префикс имени файла для отправки FTP (sendFilePrefix)',
  SendFTPAddressTypesendType: 'Тип адреса FTP для отправки (sendType)',
  ServiceTypeServiceType: 'Тип услуги (ServiceType)',
  TemplateDescriptionTemplateDescribe: 'Описание шаблона (TemplateDescribe)',
  TemplateAccessPathTemplatePath: 'Путь доступа к шаблону (TemplatePath)',
  TemplateTypeTemplateType: 'Тип шаблона (TemplateType)',
  ShutNoticeShutOutIdentification: 'Уведомление об отказе от таможенного оформления (Shut-out identification)',
  BootHelperPage: 'Вспомогательная страница загрузки (Boot helper page)',
  EDITemplateMaintenance: 'Обслуживание шаблонов EDI',
  PleaseEDIFileCombinationMethod: 'Введите способ объединения файлов EDI',
  EDIMethodMustBeType: 'Способ объединения файлов EDI должен быть числовым',
  PleaseEnterPartnerCode: 'Введите код партнера',
  PartnerMustBeNumericType: 'Код партнера должен быть числовым',
  PleaseEnterServiceType: 'Введите тип услуги',
  ServiceMustBeNumericType: 'Тип услуги должен быть числовым',
  PleaseEnterTemplateDescription: 'Введите описание шаблона',
  PleaseEnterTemplateAccessPath: 'Введите путь доступа к шаблону',
  PleaseEnterTemplateType: 'Введите тип шаблона',
  TemplateMustBeNumericType: 'Тип шаблона должен быть числовым',
  ShutMustBeNumericType: 'Сообщение о возврате должно быть числовым',
  CloudStorageID: 'ID облачного хранилища',
  TemplateFileCloudStorage: 'Облачное хранилище файлов шаблонов',
  PleaseTemplateYouWantEdit: 'Выберите шаблон для редактирования!',
  PleaseTemplateYouWantDelete: 'Выберите шаблон для удаления!',
  ConfirmDeletionOfThisTemplate: 'Подтверждаете удаление этого шаблона?',
  TemplateDeletedSuccessfully: 'Шаблон успешно удален!',
  TemplateDeletionFailed: 'Не удалось удалить шаблон!',
  BasicFailedPleaseTryAgain: 'Не удалось обновить базовый шаблон, попробуйте снова!',
  BasicTemplateUpdateSuccessful: 'Базовый шаблон успешно обновлен!',
  PleaseEnterKeywordsToSearch: 'Введите ключевое слово для поиска',
  EmailTemplateEditing: 'Редактирование шаблона электронной почты',
  PushingLink: 'Этап отправки',
  TextTemplate: 'Шаблон текста',
  Reminder: 'Подсказка',
  SendEmail: 'Отправить на email:',
  OK: 'Подтвердить',
  BasicData: 'Базовые данные',
  SystemEmail: 'Системный email',
  PicturePictureMustNot10M: 'Не удалось загрузить изображение, максимальный размер - 10 МБ!',
  PleaseAddProductDescriptionHere: 'Добавьте описание продукта здесь',
  PreSendingSupplementaryInvitationLink: 'Отправка предварительной информации с дополнительной ссылкой-приглашением',
  MarineMBLInvitationForProofreading: 'Приглашение на сверку MBL морского экспорта',
  MarineHBLInvitationForProofreading: 'Приглашение на сверку HBL морского экспорта',
  MarineExportBulkPrinting: 'Массовая печать морского экспорта',
  AirCargoStorage: 'Авиационные склады',
  BillOfLadingPrintProduction: 'Создание и печать коносамента',
  FileHistory: 'История файлов',
  InvoicePush: 'Отправка счета',
  OceanShippingAlertReminderEmail: 'Email-уведомление о морских предупреждениях',
  ReminderEmail: 'Email-напоминание',
  AirExportAlertReminderEmail: 'Email-уведомление о предупреждениях авиаэкспорта',
  RailwayAlertReminderEmail: 'Email-уведомление о железнодорожных предупреждениях',
  AirImportAlertReminderEmails: 'Email-уведомление о предупреждениях авиаимпорта',
  IntegratedAlertReminderEmails: 'Email-уведомление о предупреждениях комплексной логистики',
  BookingPageData: 'Данные страницы бронирования',
  ContentTemplate: 'Шаблон содержимого',
  Updater: 'Обновивший',
  LastUpdateTime: 'Последнее обновление',
  UploadedBeLargerThan20MB: 'Размер загружаемого изображения не должен превышать 20 МБ',
  PictureInsertionFailed: 'Ошибка вставки изображения',
  OnlyVieweditOneEmailTemplate: 'Разрешен только просмотр/редактирование одного шаблона письма',
  CompanyEmail: 'Корпоративная почта',
  PersonalEmail: 'Личная почта',
  SentSuccessfully: 'Отправлено успешно!',
  ConfirmTheModifiedContent: 'Подтверждаете внесенные изменения?',
  ConfirmCancelingTheFilledmodifiedContent: 'Подтверждаете отмену заполненных/измененных данных?',
  PleaseInTheRecipientsEmail: 'Укажите email получателя!',
  MappingType: 'Тип отображения',
  Description: 'Описание',
  Condition: 'Условие',
  SendingPlatform: 'Платформа отправки',
  EnglishName2: 'Английское название',
  ChineseName2: 'Китайское название',
  OriginalValue: 'Исходное значение',
  NewValue: 'Новое значение',
  EditMapping: 'Редактировать отображение',
  CreateMapping: 'Создать отображение',
  PleaseEnterMappingType: 'Введите тип отображения',
  PleaseEnterTheOriginalValue: 'Введите исходное значение',
  PleaseEnterTheNewValue: 'Введите новое значение',
  Branch: 'Филиал',
  EnableAutomaticPush: 'Включить автоматическую рассылку',
  SOPPushChannel: 'Канал рассылки SOP:',
  PushOnlyAfterConfirmingRecipient: 'Отправлять статус SOP только после подтверждения получателя:',
  PleaseSendersEmailWhichEmails: 'Отметьте email для отправки писем из списка ниже.',
  Username2: 'Имя пользователя:',
  EmailPasswordauthorizationCode: 'Пароль/код авторизации почты:',
  EmailDisplayName: 'Отображаемое имя письма:',
  SenderServer: 'SMTP-сервер:',
  Port: 'Порт:',
  WhenActualSenderIsEmail: 'При выборе личной почты отправителем будет зарегистрированный email пользователя.',
  CompanyEnglishAbbreviation: 'Английская аббревиатура компании:',
  BasicConfiguration: 'Основные настройки',
  SMS: 'SMS',
  Open: 'Включить',
  Close: 'Отключить',
  EmailConfiguration: 'Настройки почты',
  Signature: 'Подпись:',
  EnableSignature: 'Активировать подпись',
  SMSConfiguration: 'Настройки SMS',
  PleaseAProductDescriptionHere: 'Добавьте описание продукта здесь',
  CompanyAbbreviationCannotBeEmpty: 'Китайская аббревиатура компании обязательна!',
  CompanyUsernameCannotBeEmpty: 'Имя пользователя корпоративной почты обязательно!',
  CompanyCodeCannotBeEmpty: 'Пароль/код авторизации корпоративной почты обязателен!',
  CompanyServerCannotBeEmpty: 'SMTP-сервер корпоративной почты обязателен!',
  CompanyNumberMustBeNumber: 'Порт корпоративной почты должен быть числовым!',
  PersonalUsernameCannotBeEmpty: 'Имя пользователя личной почты обязательно!',
  PersonalServerCannotBeEmpty: 'Сервер отправки личной почты не может быть пустым!',
  PersonalNumberMustBeNumber: 'Порт личной почты должен быть числом!',
  AdditionalOutputAssociatedTemplate: 'Дополнительный шаблон связанного вывода',
  TemplateEngine: 'Шаблонизатор',
  FilterScript: 'Скрипт фильтрации',
  BranchSerialNumber: 'Номер филиала',
  TemplateFile: 'Файл шаблона',
  TemplateClass: 'Класс шаблона',
  TemplateUsage: 'Назначение шаблона',
  Print: 'Печать',
  CreateTemplate: 'Создать шаблон',
  TemplateFileCloudStorageID: 'ID облачного хранилища файла шаблона',
  TemplateSerialNumber: 'Номер шаблона',
  SchemaTypeNotMaintained: 'SchemaType не поддерживается',
  CannotCheckWhetherTheCorrect: 'Базовая информация шаблона не найдена, проверьте правильность источника данных шаблона!',
  SchemaTypeCannotBeEmpty: 'Schema Type не может быть пустым.',
  TemplateTypeCannotBeEmpty: 'Template Type не может быть пустым',
  TemplateDescCannotBeEmpty: 'Template Type Desc не может быть пустым',
  ChineseNameLengthExceeds20: 'Длина китайского имени превышает 20!',
  PleaseSelectStatusType: 'Выберите тип статуса!',
  PleaseSelectATriggerType: 'Выберите тип триггера',
  DropThisConditionForGoods: '*Пустое выпадающее поле означает, что условие не учитывается. Например: не учитывать тип груза',
  PushTarget: 'Объект рассылки',
  BookingSuccess: 'Бронирование успешно',
  WarehouseEntryNotification: 'Уведомление о поступлении на склад',
  BillOfLadingIssuance: 'Выдача коносамента',
  DesignatedFreightAgent: 'Указанный грузовой агент',
  DesignatedPostAndDesignatedPersonnel: 'Указанная должность и назначенный сотрудник',
  PleaseSelectDataFirst: 'Сначала выберите данные',
  AreToDeleteTheRecord: 'Подтверждаете удаление выбранных записей?',
  Hint: 'Подсказка',
  PleaseEnterTestEmailAddress: 'Введите тестовый email!',
  PleaseEnterTestMobileNumber: 'Введите тестовый номер телефона!',
  MobileOnlyBeANumber: 'Номер телефона должен быть действительным числом!',
  MobileNumberFormatError: 'Неверный формат номера телефона!',
  SendingSuccessful: 'Отправлено успешно!',
  SendingFailed: 'Ошибка отправки!',
  ChineseName3: 'Китайское имя',
  EnglishName3: 'Английское имя',
  PublicOrNot: 'Публичный доступ',
  Remark: 'Примечание',
  AutomaticTrigger: 'Автоматический триггер',
  DoNotSendNotification: 'Не отправлять уведомления',
  DesignatedPost: 'Назначенная должность',
  Documentary: 'Документация',
  LineManager: 'Ответственный за маршрут',
  PleaseEnterChineseName: 'Введите китайское имя',
  PleaseEnterEnglishName: 'Введите английское имя',
  PleaseSelectTriggerType: 'Выберите тип триггера',
  PleaseSelectStatusType2: 'Выберите тип статуса',
  ThereSameCodePleaseEnter: 'Такой код уже существует, введите заново!',
  ThereSameChineseNameEnter: 'Такое китайское название уже существует, введите заново!',
  ThereSameEnglishNameEnter: 'Такое английское название уже существует, введите заново!',
  PleaseEnterFieldName: 'Введите название поля',
  PleaseEnterFieldEnglishName: 'Введите английское название поля',
  AreToDeleteTheType: 'Подтверждаете удаление типа триггера?',
  AllCharts: 'Все графики',
  BusinessCharts: 'Бизнес-графики',
  FinancialCharts: 'Финансовые графики',
  ControlMode: 'Режим контроля:',
  ReceivingOrder: 'Прием заказов',
  Printing: 'Печать',
  BillOfLadingRelease: 'Выпуск коносамента',
  NoDeduction: 'Не блокировать',
  OnlyHBL: 'Только HBL',
  OnlyHBLDeductHBL: 'Блокировать только HBL',
  OnlyMBL: 'Только MBL',
  OnlyMBLDeductMBL: 'Блокировать только MBL',
  HBLAtTheSameTime: 'И HBL, и MBL',
  HBLAtTheSameTime2: 'Блокировать и HBL, и MBL',
  OnlyHBLWithoutDeductingMBL: 'Блокировать только HBL, не MBL',
  DoHBLOnlyDeductMBL: 'Не блокировать HBL, только MBL',
  DocumentCirculation: 'Документооборот',
  ApplyTheHeadOfficesSettings: 'Применить настройки головной компании',
  ReminderMode: 'Режим напоминания',
  LockingMode: 'Режим блокировки',
  WhenRemindersAndTheLocked: 'При превышении кредитного лимита - только уведомление, без блокировки',
  WhenOrderUntilItApproved: 'При превышении кредитного лимита - блокировка до автоматического разблокирования или ручного одобрения',
  NotificationReminder: 'Уведомления:',
  LockingControl: 'Контроль блокировки:',
  Event: 'Событие',
  IsLocked: 'Блокировать или нет',
  ControlObject: 'Объект контроля',
  ControlMethod: 'Способ контроля',
  PrintTemplate: 'Шаблон печати',
  Document: 'Документы',
  EmailAndReminder: 'Почта и уведомления',
  None: 'Нет',
  SaveAndLock: 'Блокировка после сохранения',
  CannotSave: 'Нельзя сохранить',
  BusinessLocked: 'Операция заблокирована',
  BusinessUnlocked: 'Операция разблокирована',
  CreditControlExceed: 'Превышение кредитного лимита',
  CreditControlChange: 'Изменение кредитного контроля',
  AddCopyFormalBusiness: 'Добавить/копировать официальную операцию',
  OperationSupervisor: 'Операционный менеджер',
  SalesSupervisor: 'Менеджер по продажам',
  CreditControlSupervisor: 'Менеджер по кредитному контролю',
  BusinessCustomerService: 'Клиентский сервис',
  MBLTabPrint: 'Печать вкладки MBL',
  MBLSplitMergePrint: 'Печать разделения/объединения MBL',
  HBLOriginalPrint: 'Печать оригинала HBL',
  HBLSplitMergeOriginalPrint: 'Печать оригинала разделения/объединения HBL',
  HBLTelexPrint: 'Печать электронного релиза HBL',
  HBLSplitMergeTelexPrint: 'Печать электронного релиза разделения/объединения HBL',
  BookingTabPrint: 'Печать вкладки бронирования',
  BasicTab: 'Основная вкладка',
  MAWBTab: 'Вкладка MAWB',
  HAWBTab: 'Вкладка HAWB',
  BookingEDI: 'EDI бронирования',
  BillOfLadingEDI: 'EDI коносамента',
  ReturnOrder: 'Возврат документов',
  AbnormalStatus: 'Аномальный статус',
  User: 'Пользователь',
  IPAddress: 'IP-адрес',
  PleaseEnterTheIPAddress: 'Введите IP-адрес.',
  IndicatesUnrestricted: 'Означает отсутствие ограничений',
  IPAddressCannotBeEmpty: 'IP-адрес не может быть пустым',
  PleaseSelectAUser: 'Выберите пользователя',
  ThisAlreadyAddedAnWhitelist: 'Этот пользователь уже добавлен в белый список IP',
  ExistingSameIPAddress: 'Такой IP-адрес уже существует',
  PleaseSelectData: 'Выберите данные',
  BusinessType: 'Тип бизнеса',
  BillOfLadingType: 'Тип коносамента',
  DesignatedShippingLine: 'Указанная судоходная компания',
  Expression: 'Выражение',
  Example: 'Пример',
  LetterSuffix: 'Буквенный суффикс',
  LetterexcludingIAndO: 'Буквенный суффикс (без I и O)',
  NumberSuffix: 'Цифровой суффикс',
  MasterBillExtension: 'Последовательное продолжение основного номера',
  SuffixSeparator: 'Разделитель суффикса',
  Constant: 'Константа',
  AddRule: 'Добавить правило',
  PleaseEnterRuleName: 'Введите название правила',
  Reset: 'Сброс',
  ServiceCodeMaintenance: 'Обслуживание кодов услуг',
  BusinessTypelob: 'Тип бизнеса (LOB)',
  CargoPickupType: 'Тип сбора груза',
  BranchCodeoffice: 'Код филиала (office)',
  Salesperson: 'Торговый представитель',
  NetCodenetCode: 'Код сетевого управления (netCode)',
  SalesDepartment: 'Отдел продаж',
  OperationsDepartment: 'Операционный отдел',
  OverseasWarehouseCodeFBAFC: 'Код зарубежного склада (FBA FC)',
  PortCodeport: 'Код порта (port)',
  DeliveryPlaceCodeport: 'Код места доставки (port)',
  PolCode: 'Код порта отправления (POL)',
  DeparturePortCode: 'Код порта отправления',
  DestinationPortCode: 'Код порта назначения',
  DeparturePortExchangeCode: 'Код обмена порта отправления',
  DestinationPortExchangeCode: 'Код обмена порта назначения',
  ServiceCode: 'Сервисный код',
  OverseasAgentCode: 'Код зарубежного агента',
  JobNumberjobNo: 'Номер задания (jobNo)',
  ReceivableOrPayable: 'Дебиторская задолженность (RP)',
  Jobyear: 'Job (год)',
  Yearyear: 'Год (year)',
  Length: 'Длина',
  Jobmonth: 'Job (месяц)',
  Monthmonth: 'Месяц (month)',
  Dateday: 'Дата (day)',
  JobSequenceNumberjobSequence: 'Серийный номер Job (jobSequence)',
  RandomLetters: 'Буквы случайны',
  SequenceNumbersequence: 'Серийный номер (sequence)',
  CustomBusinessTypecustomJobType: 'Пользовательский тип задания (customJobType)',
  SequenceNumberSettings: 'Настройка серийного номера',
  NeverResetN: 'Никогда не сбрасывать (N)',
  ResetByYearY: 'Сброс по году (Y)',
  ResetByMonthM: 'Сброс по месяцу (M)',
  ResetByDayD: 'Сброс по дню (D)',
  BusinessDate: 'Дата операции',
  DepartureDate: 'Дата отправления',
  ShippingDate: 'Дата отгрузки',
  ArrivalDate: 'Дата прибытия в порт',
  BranchSequenceNumberIndependent: 'Независимая серия филиала',
  CustomJobTypeSequenceNumberIndependent: 'Независимая серия пользовательского типа задания',
  PaymentDirectionSerialNo: 'Серийный номер направления платежа независим',
  DomesticBill: 'Внутренний счёт',
  DomesticBillNo: 'Номер внутреннего счёта',
  ReceivableAndPayableio: 'Дебиторская/кредиторская задолженность (io)',
  BranchConfigurationIndependent: 'Независимая конфигурация филиала',
  JoiningDeclarationNumberRule: 'Правила добавления номеров консолидированных накладных',
  TakeBillDateOnYearMonthDay: 'Дата выставления счета',
  TakeDocumentDateOnYearMonthDay: 'Дата получения заказа',
  TakeActualPayDateOnYearMonthDay: 'Дата фактического получения',
  UseBillDateOnYearMonthDay: 'Использовать дату выверки счетов в качестве года, месяца, даты для контроля потока.',
  UseDocumentDateOnYearMonthDay: 'Использовать дату выставления счетов в качестве контрольного номера потока года, месяца и даты.',
  UseActualPayDateOnYearMonthDay: 'Использование фактических поступлений и выплат в качестве контроля по годам, месяцам, датам и последовательным номерам.',
  DomesticStatement: 'Внутренние счета',
  ForeignStatement: 'Счета за рубежом',
  AddConstant: 'Добавить константу',
  PleaseToJobNumberSettings: 'См. настройки номера задания',
  ConstantCannotBeEmpty: 'Константа не может быть пустой',
  ConstantSpecialCharacters$: 'Константа не должна содержать специальные символы $, {, }',
  ConfigurationCannotBeEmpty: 'Конфигурация не может быть пустой!',
  LengthExceedsAllowableLength: 'Длина превышает допустимую!',
  ConfigurationExpressionCannotBeEmpty: 'Выражение конфигурации не может быть пустым',
  ThereAtLeastOneName: 'Должно быть хотя бы одно название правила',
  JoiningMustChooseAtItem: 'Необходимо выбрать хотя бы одно правило добавления номеров консолидированных накладных',
  ChangingInTheSystemModification: 'Изменение конфигурации может повлиять на запрос исторических данных в системе. Сохранить изменения?',
  RuleNameAlreadyExists: 'Название правила уже существует',
  SaveFailed: 'Не удалось сохранить',
  AreWantToDeleteRule: 'Вы уверены, что хотите удалить это правило?',
  Prompt: 'Подсказка',
  BranchBankAccount: 'Банковский счет филиала',
  SetAsDefaultRMBAccount: 'Установить как счет RMB по умолчанию',
  SetAsDefaultUSDAccount: 'Установить как счет USD по умолчанию',
  Currency: 'Валюта',
  Bank: 'Банк',
  Abbreviation: 'Сокращение',
  AccountNumber: 'Номер счета',
  RMBDefaultAccount: 'Счет RMB по умолчанию',
  USDDefaultAccount: 'Счёт USD по умолчанию',
  BankChineseAddress: 'Адрес банка на китайском',
  BankEnglishAddress: 'Адрес банка на английском',
  TheItCannotBeAccount: 'Валюта этого счёта не RMB, нельзя выбрать как счёт RMB по умолчанию.',
  TheItCannotBeAccount2: 'Валюта этого счёта не USD, нельзя выбрать как счёт USD по умолчанию.',
  NameDoYouWantSave: ']Имена уже существуют или сохранены?',
  SaveWantToCloseWindow: 'Сохранено успешно, закрыть окно?',
  CurrencyCannotBeEmpty: 'Валюта не может быть пустой',
  CodeCannotBeEmpty: 'Код не может быть пустым',
  EnglishNameCannotBeEmpty: 'Английское название не может быть пустым',
  AccountNumberCannotBeEmpty: 'Номер счёта не может быть пустым',
  TaxControlDiskNumberMaintenance: 'Обслуживание номеров налоговых контроллеров',
  Number: 'Номер',
  InvoiceCode: 'Код точки выставления счетов',
  UsageDepartment: 'Использующее подразделение',
  TheNumberCannotBeRepeated: 'Номера не должны повторяться!',
  InvoiceCodeCannotBeRepeated: 'Коды точек выставления счетов не должны повторяться!',
  OneToMaintainMultipleNumbers: 'Одному подразделению запрещено обслуживать несколько номеров налоговых контроллеров',
  NumberCannotBeEmpty: 'Номер не может быть пустым!',
  InvoiceCodeCannotBeEmpty: 'Код точки выставления счетов не может быть пустым!',
  UsageDepartmentCannotBeEmpty: 'Использующее подразделение не может быть пустым!',
  DepartmentCode: 'Код подразделения',
  JobNumberEncodingField: 'Поле кода рабочего номера',
  IsItASettlementCompany: 'Является ли расчётной компанией',
  AddDepartment: 'Добавить подразделение',
  TheOfTheDepartmentEmpty: 'Китайское или английское название подразделения не может быть пустым',
  EnabledSuccessfully: 'Успешно активировано!',
  DisabledSuccessfully: 'Успешно деактивировано!',
  SaveSuccessfully: 'Успешно сохранено!',
  CompanyCode: 'Код компании',
  BranchChineseName: 'Китайское название филиала',
  ChineseAddress: 'Адрес на китайском',
  BranchEnglishName: 'Английское название филиала',
  City: 'Город',
  PostalCode: 'Почтовый индекс',
  Fax: 'Факс',
  Phone: 'Телефон',
  LocalCurrency: 'Локальная валюта',
  DefaultAirport: 'Аэропорт по умолчанию',
  DefaultSeaport: 'Морской порт по умолчанию',
  SeaBillOfLadingAddress: 'Адрес коносамента для морских перевозок',
  AirBillOfLadingAddress: 'Адрес авианакладной',
  RMBAccount: 'Счёт в RMB',
  USDAccount: 'Счёт в USD',
  OverseasBillAddress: 'Адрес зарубежного счёта',
  DomesticBillAddress: 'Адрес внутреннего счёта',
  OverseasEDICode: 'Зарубежный код EDI',
  MarkupTaxRate: 'Налоговая ставка наценки',
  InvoiceTaxRate: 'Налоговая ставка выставления счетов',
  SettlementEmail: 'Расчётный email',
  TaxSystemInterfaceAddress: 'Адрес интерфейса налоговой системы',
  TaxControlPanelNumber: 'Номер налогового контроллера',
  InvoiceTitle: 'Название в счете-фактуре',
  InvoiceAddress: 'Адрес в счете-фактуре',
  TaxpayerIdentificationNumber: 'ИНН (Идентификационный номер налогоплательщика)',
  ElectronicTicketPlatformCode: 'Код платформы электронных счетов',
  ElectronicTicketPassword: 'Пароль электронного счета',
  ElectronicTaxpayerIdentificationNumber: 'ИНН для электронных счетов',
  ElectronicTaxpayerAuthorizationCode: 'Код авторизации налогоплательщика для электронных счетов',
  ElectronicTicketServiceRequestAddress: 'Адрес запроса сервиса электронных счетов',
  InvoiceCancellationRequestAddress: 'Адрес запроса аннулирования счета',
  RelatedPartners: 'Связанные партнеры',
  EFreighAMSAccount: 'E-Freight (аккаунт AMS)',
  EFreighACIAccount: 'E-Freight (аккаунт ACI)',
  CopyCompany: 'Копировать компанию',
  AddBranch: 'Добавить филиал',
  CopyBranch: 'Копировать филиал',
  BankAccount: 'Банковский счет',
  SelectFile: 'Выбрать файл',
  RemoveFile: 'Удалить файл',
  NewBranchInformation: 'Информация о новом филиале',
  N1DepartmentsAndPositionBranch: '1. Все отделы и должностные права под этим филиалом в управлении правами',
  N2ParameterConfiguration: '2. Настройка параметров',
  N3OrderNumberConfiguration: '3. Настройка номеров',
  Preview: 'Предпросмотр',
  Apply: 'Применить',
  CompanyCodeCannotBeEmpty2: 'Код компании не может быть пустым.',
  TheOfTheCompanyEmpty: 'Китайское или английское название компании не может быть пустым.',
  LocalNotAllowedToEmpty: 'Локальная валюта не может быть пустой.',
  CopyCompanySucceeded: 'Компания успешно скопирована',
  AreYouSureToDelete: 'Подтверждаете удаление?',
  DeletedSuccessfully: 'Успешно удалено.',
  NameCannotBeEmpty: 'Название не может быть пустым',
  SubmitSuccessfully: 'Успешно отправлено',
  RoleName: 'Название роли',
  PleaseSelect: 'Пожалуйста, выберите',
  Individual: 'Лицо',
  DepartmentGroup: 'Группа отделов',
  BatchAddRolePermissions: 'Массовое добавление прав ролей',
  UpdatePermissionGroup: 'Обновить группу прав',
  Removegtgt: 'Удалить &gt;&gt;',
  ltltAdd: '&lt;&lt; Добавить',
  PermissionName: 'Название права',
  PermissionClass: 'Класс прав',
  PermissionType: 'Тип прав',
  PermissionPoint: 'Точка права',
  Error: 'Произошла ошибка',
  AreDeleteTheCurrentlyRoles: 'Подтверждаете удаление выбранного?',
  PleaseOrMoreRolesDelete: 'Пожалуйста, отметьте одну или несколько ролей для удаления!',
  PleaseOneOrMoreRoles: 'Пожалуйста, выберите одну или несколько ролей',
  PleaseOneOrMorePermissions: 'Пожалуйста, выберите одно или несколько разрешений',
  BatchAddSuccessfully: 'Массовое добавление успешно',
  PleaseEnterTheRoleName: 'Введите название роли',
  Meaning: 'Значение',
  PleaseEnterTheServiceCode: 'Введите сервисный код',
  PleaseTheServiceCodeMeaning: 'Введите значение сервисного кода',
  Defaulted: 'По умолчанию',
  SetAsDefault: 'Установить по умолчанию',
  SuccessSetting: 'Настройка успешна',
  AreToDeleteThisCode: 'Вы уверены, что хотите удалить этот сервисный код?',
  SelectCustomer: 'Выбор клиента',
  PleaseCodeEnglishNameName: 'Введите сокращение, код, английское или китайское название',
  PleaseSelectACustomer: 'Пожалуйста, выберите клиента.',
  DataCargoTrackingPurchaseEffect: 'Услуги передачи данных: планы судов в порту, данные о контейнерах в портовой зоне, отслеживание грузов судоходными компаниями. Конфигурация на этой странице вступит в силу после покупки услуги передачи данных.',
  PushFCLLCLType: 'Тип передачи полного контейнера (FCL)',
  PleaseSelectFCLLCLType: 'Выберите тип полного контейнера (FCL)',
  DoServicesNeedToVoyage: 'Требуется ли обновлять название судна и рейс в услуге передачи данных планов судов в порту?',
  IsTrackingLimitedToDeparture: 'Ограничивается ли порт отправления при отслеживании грузов судоходной компанией?',
  EnterpriseType: 'Тип предприятия',
  SelectServiceEnabledSelectEffect: 'Выбор "Все" - включить услугу для всех клиентов; "Белый список" - включить услугу для выбранных клиентов; "Чёрный список" - отключить услугу для выбранных клиентов. Вступают в силу только последние сохранённые настройки.',
  WhiteList: 'Белый список',
  BlackList: 'Чёрный список',
  DeleteConfiguration: 'Удалить конфигурацию',
  PushCondition: 'Условия передачи',
  DataSettings: 'Настройки данных',
  SynchronizationLogicSettings: 'Настройки логики синхронизации',
  ClearSettings: 'Очистить настройки',
  unBerthPlanDateSynETD: 'Синхронизировать запланированное время отхода (ETD)',
  estimatedArrivalTimeSynETA: 'Синхронизировать ожидаемое время прибытия (ETA)',
  ClearVoyageAndShipPeriodData: 'Очистить данные расписания при изменении названия судна и рейса',
  MorePushConfiguration: 'Дополнительные настройки передачи...',
  PortPortOfDepartureRange: 'Диапазон портов отправления для передачи данных портовой зоны',
  Shanghai: 'Шанхай',
  Ningbo: 'Нинбо',
  Xiamen: 'Сямынь',
  Shenzhen: 'Шэньчжэнь',
  Qingdao: 'Циндао',
  Tianjin: 'Тяньцзинь',
  Fuzhou: 'Фучжоу',
  Dalian: 'Далянь',
  NanSha: 'Наньша, Гуанчжоу',
  CustomerList: 'Список клиентов',
  CloseOpen: 'Закрыть настройки подключения услуги передачи данных',
  DataServiceSetting: 'Параметры службы данных',
  DataServiceNotUpdateValue: 'Служба данных не обновляет значения поля',
  ConditionType: 'Тип условия',
  Consignor: 'Уполномоченная организация',
  PleaseSelectConsignor: 'Выберите уполномоченную организацию',
  SubscriptionScope: 'Область подписки',
  NoConfigurationItemsMade: 'Нет никаких настроек.',
  DeletedSuccessfully2: 'Успешно удалено!',
  FCLLCLTypeNotSelected: 'Тип полного контейнера (FCL) не выбран',
  PleaseSelectWhiteListCustomers: 'Пожалуйста, выберите клиентов из белого списка',
  PleaseSelectBlackListCustomers: 'Пожалуйста, выберите клиентов из черного списка',
  SavedSuccessfully: 'Сохранение успешно!',
  PleaseLeastOneDataDeletion: 'Пожалуйста, выберите хотя бы одну запись для удаления!',
  PushServiceProviderConfiguration: 'Настройка провайдера push-услуг',
  PushServiceName: 'Название push-услуги',
  ServiceProviders: 'Провайдер',
  ShanghaiPort: 'Порт Шанхай',
  ShippingCompanyCargoTracking: 'Отслеживание грузов судоходной компании',
  Seabourne: 'Хайбо',
  FreighTower: 'Фэйтуо',
  AirCargoTracking: 'Отслеживание авиагрузов',
  MaritimeDataPush: 'Push-передача морских данных',
  AirFreightDataPush: 'Push-передача авиационных данных',
  YundangNet: 'Юньдан',
  SeaButler: 'Хайгуаньцзя',
  NingboPort: 'Порт Нинбо',
  XiamenPort: 'Порт Сямынь',
  QingdaoPort: 'Порт Циндао',
  FuzhouPort: 'Порт Фучжоу',
  PortShipSchedule: 'План судов в порту',
  ShenzhenPort: 'Порт Шэньчжэнь',
  DalianPort: 'Порт Далянь',
  TianjinPort: 'Порт Тяньцзинь',
  DataPushCustomerList: 'Список клиентов для push-передачи данных',
  CustomerWhitelist: 'Белый список клиентов:',
  PushContent: 'Настройка контента морской push-передачи',
  AirPushContent: 'Настройка контента авиационной push-передачи',
  PortContainerData: 'Данные контейнерных грузов в портовой зоне',
  NoCustomerSelected: 'Клиент не выбран.',
  UpdateSuccessful: 'Обновление успешно',
  Seaport: 'Морской порт,',
  Airport: 'Аэропорт,',
  ChargeItem: 'Статьи оплаты,',
  Route: 'Маршрут,',
  Network: 'Сеть,',
  Currency2: 'Валюта,',
  ContainerType: 'Тип контейнера,',
  Packaging: 'Упаковка,',
  BillOfLadingType2: 'Тип коносамента,',
  CargoType: 'Тип груза,',
  TradeTerms: 'Торговые условия,',
  TransportTerms: 'Транспортные условия,',
  TradeMode: 'Способ торговли,',
  AirFreightServiceItems: 'Статьи авиационных тарифов,',
  RelatedPort: 'Связанные порты,',
  AirCargoBillMiscellaneous: 'Дополнительные сборы авианакладной,',
  CustomerType: 'Тип клиента,',
  BillOfLadingMethod: 'Способ коносамента,',
  CustomBusinessType: 'Пользовательский тип операции,',
  CirculatingDocumentType: 'Тип циркулирующего документа',
  Initialize: 'Инициализация',
  Success: 'Успешно',
  Failure: 'Неудача',
  AddPort: 'Добавить порт',
  PleaseSelectPort: 'Выберите порт',
  Operator: 'Оператор',
  PleaseSelectPort2: 'Пожалуйста, выберите порт!',
  PleaseSelectOperator: 'Выберите связанного пользователя.',
  TheAlreadyMaintainedThisInformation: 'Для этого пользователя уже настроена связь',
  PleaseNameEmailEtcQuery: 'Введите нечеткий запрос (китайское имя, английское имя, email и т.д.)...',
  NetManagementCode: 'Код сетевого управления',
  AfterBeAbleToContinue: 'После деактивации пользователь не сможет войти в систему. Продолжить?',
  Valid: 'Активен',
  Invalid: 'Неактивен',
  PleaseEnterEmail: 'Введите email',
  EditSuccess: 'Редактирование успешно',
  EmailDuplicate: 'Email уже существует!',
  UserAllowsInputLettersNumbers: 'Код пользователя должен содержать только буквы и цифры.',
  Operator2: 'Оператор:',
  PortCode: 'Код порта',
  RelatedUser: 'Связанные пользователи',
  BusinessMode: 'Бизнес-модель',
  PleaseDataYouWantDelete: 'Выберите данные для удаления.',
  AreYouWantToDelete2: 'Подтвердите массовое удаление выбранных {0} элементов конфигурации?',
  DeleteSuccess2: 'Удаление успешно.',
  AddRoleUser: 'Добавить пользователя с ролью',
  AddUserWithUnassignedRole: 'Добавить пользователя без назначенной роли',
  Query: 'Поиск',
  SelectDepartment: 'Выберите отдел',
  AreYouWantToDelete3: 'Подтвердите удаление?',
  SelectedUsersAlreadyExist: 'Выбранный пользователь уже существует',
  AddSuccessfully: 'Добавление успешно',
  CopyRole: 'Копировать роль',
  PasteRole: 'Вставить роль',
  PleaseRoleYouWantCopy: 'Выберите роль для копирования!',
  PleaseYouWantToRole: 'Выберите отдел для вставки роли!',
  IPWhitelist: 'Белый список IP',
  UserWhitelist: 'Белый список пользователей',
  JobNumber: 'Номер рабочего листа',
  NoteMainAndSplit19: 'Примечание: максимальная длина номера рабочего листа - 21 символ. Последние 2 символа зарезервированы для маркировки основного и разделенного листов, поэтому длина номера на этой странице не должна превышать 19.',
  MainOrderNumber: 'Номер основного листа',
  NoteNumberIsUpLong: 'Примечание: максимальная длина номера коносамента - 16 символов.',
  SubOrderNumber: 'Номер разделенного листа',
  NoteIsUpToLong: 'Примечание: максимальная длина номера разделенного листа - 21 символ.',
  WarehouseEntryNumber: 'Номер складирования',
  BookingNumber: 'Номер бронирования',
  NoteYouHaveSelectedLength: 'Примечание: максимальная длина номера складирования - 21 символ. Если выбран номер рабочего листа, учитывайте его фактическую длину.',
  OverseasBillNumber: 'Номер зарубежного счета',
  NoteIsUpToLong2: 'Примечание: максимальная длина номера зарубежного счета - 16 символов.',
  PaymentApplicationForm: 'Заявка на оплату',
  PaymentApprovalForm: 'Согласование платежа',
  NoteIsUpToLong3: 'Примечание: номер заявки на оплату не должен превышать 16 символов.',
  NoteIsUpToLong4: 'Примечание: Внутренний номер счета до 16 цифр.',
  BillOfLadingSerialNumber: 'Серийный номер коносамента',
  SeaFreightExport: 'Морской экспорт',
  SeaFreightImport: 'Морской импорт',
  AirFreightExport: 'Авиаэкспорт',
  AirFreightImport: 'Авиаимпорт',
  FBASeaFreight: 'FBA морская доставка',
  FBAAirFreight: 'FBA авиадоставка',
  ReportName: 'Название отчета',
  Report: 'Отчет',
  PermissionAddedSuccessfully: 'Права успешно добавлены',
  PleaseReportLinkedToRole: 'Выберите отчеты, связанные с ролью',
  AreToDeleteTheRole: 'Вы уверены, что хотите удалить выбранную роль?',
  PermissionDeletedSuccessfully: 'Права успешно удалены',
  QuickSearchAdTheme: 'Быстрый поиск: тема рекламы',
  AdCode: 'Номер рекламы',
  AdThemename: 'Тема/Название рекламы',
  AdLocation: 'Рекламное место',
  BelongsToPage: 'Принадлежащая страница',
  BelongsToModule: 'Принадлежащий модуль',
  BelongingSystem: 'Принадлежащая система',
  PageViews: 'Количество просмотров',
  Clicks: 'Количество кликов',
  ClickRate: 'CTR (кликабельность)',
  NumberOfClickUsers: 'Количество уникальных кликов',
  N0FileTypeNotSelected: 'Тип файла {0} не выбран.',
  NoteCopyFollowingInformation: 'Примечание: выбранный вами для копирования 【{0}】 содержит следующую информацию:',
  NXRoles: 'ролей?',
  BranchSelection: 'Выбор филиала',
  CheckParentCompanyWithSubsidiary: 'Выбор родительской компании включает выбор дочерних компаний',
  CurrentlySelectedProject: 'Текущие выбранные элементы:',
  AlertContentConfiguration: 'Настройка содержания оповещения',
  AlertTimeConfiguration: 'Настройка времени оповещения',
  SopTimeSetUp: 'Настройка времени SOP',
  SetPersonalEmail: 'Пожалуйста, настройте личную почту',
  SetPersonalEmailNote1: 'После настройки личной почты отправителем будет личная почта каждого пользователя. Убедитесь, что каждый пользователь правильно настроил личную почту.',
  SetPersonalEmailNote2: 'Если настройки неверны, в качестве отправителя будут использоваться корпоративная почта и системная почта.',
  SetPersonalEmailStep1: 'Шаг 1: Перейдите в Настройки и инструменты, настройка личной почты.',
  SetPersonalEmailStep2: 'Шаг 2: Укажите пароль/код авторизации личной почты, сервер отправки, порт и подпись.',
  SetPersonalEmailStep3: 'Шаг 3: После сохранения можно использовать личную почту в качестве отправителя.',
  WhtTax: 'Режим налога WHT',
  WhtTaxTip: 'Применяется в таких странах, как Таиланд, где есть WHT. После включения можно учитывать операции и налог WHT, а также вычитать сумму WHT при списании.',
  SendDestinationPortProxyDocuments: 'История файлов - отправка документов агенту в порту назначения',
  MainTicketAttachmentItem: 'Приложения к главному коносаменту',
  SmallTicketAttachmentItem: 'Приложения к дополнительному коносаменту',
  SelectFileType: 'Выбор типа файла',
  IncludeSlaveAttachLabel: 'При отправке главного коносамента по почте вложения должны включать файлы дополнительного коносамента.',
  AutoGenerationManifestLabel: 'Если в главном коносаменте нет файлов MANIFEST, печать автоматически выполняется по номеру контейнера.',
  FileAttachmentTip: 'Если требуется проверять наличие вложений перед отправкой, настройте это в разделе "Базовые настройки - Настройка правил проверки".',
  FileAttachmentTip2: 'По умолчанию система автоматически сопоставляет файлы вложений согласно способу HBL коносамента. Эту функцию можно отключить в "Базовые настройки - Управление конфигурацией".',
  YearMonthEtdTip: 'При одновременном выборе job(год) и job(месяц) значения берутся согласно выбранному году и месяцу в [Дате отплытия].',
  YearMonthEtaTip: 'При одновременном выборе job(год) и job(месяц) значения берутся согласно выбранному году и месяцу в [Дате прибытия в порт].',
  RiYearMonthEtaTip: 'При одновременном выборе job(год) и job(месяц) значения берутся согласно выбранному году и месяцу в [Дате прибытия].',
  NotifySuperiors: 'Непосредственный руководитель сотрудника',
  NotifySuperiorsCheckTip: 'При выборе [Непосредственного руководителя сотрудника] необходимо выбрать хотя бы одну [Указанную должность]!',
  AddOnlyCurrentTemplate: 'Добавить только в текущий шаблон',
  AddOtherSameLobTempalte: 'Добавить в другие шаблоны того же типа бизнеса',
  OnlyModifyCurrentTemplate: 'Изменить только текущий шаблон ',
  ModifyTemplateContaneNode: 'Изменить все шаблоны, содержащие этот узел',
  AddRanges: 'Область добавления',
  ModifyRanges: 'Область изменения',
  ApplicationTemplate: 'Применить шаблон',
  SetNodeLimitTip: 'При настройке узлов необходимо сохранять единообразие [кода], [китайского названия] и [английского названия] узлов SOP в рамках одного типа бизнеса.',
  SelectSOPTemplateForNode: 'Выберите SOP-шаблон для применения к узлу',
  ConfirmJoinSelectTemplate: 'Подтверждаете добавление в выбранные SOP-шаблоны?',
  AddTemplateSameNode: 'Добавить во все шаблоны с такими же узлами',
  ModifyTemplateContinNode: 'Изменить все шаблоны, содержащие этот статус узла',
  HblBlWayAttachLabel: 'В соответствии со способом и типом коносамента извлекается соответствующий HBL-файл',
  HblWithoutGenerateAttachLabel: 'При отсутствии HBL-файлов автоматически печатается образец HBL',
  ConfirmedPrintHblLabel: 'Когда статус HBL "Подтвержден, но не выдан", автоматически печатается образец HBL',
  PleaseSetSlaveAttach: 'Сначала задайте тип файла для вложений квитанций!',
  QueryFileType: 'Тип запрашиваемого файла:',
  HblCfmStateOriginDraftLabel: 'При статусе HBL "Не выдан" извлекается образец HBL, при статусе "Выдан" извлекается сам HBL-документ',
  BillOfLading: 'Коносамент',
  AssociatedRoutesAndPorts: 'Связать маршрут и порт',
  AirlineChineseName: 'Китайское название маршрута',
  PortEnglishName: 'Английское название порта',
  OperationPosition: 'Рабочая позиция',
  UserConfigDuplicate: 'У сотрудника {0} уже есть данные конфигурации, не настраивайте повторно.',
  ConfirmSaveModifiedInfo: 'Подтверждаете сохранение изменений?',
  PleaseSelectARoute: 'Выберите маршрут',
  AssociatedPermissions: 'Связанные права доступа',
  OptionalPositionsRoles: 'Доступные ответственные позиции ограничены ролями пользователя',
  ResponsiblePosition: 'Ответственная позиция',
  SelectResponsiblePosition: 'Выберите ответственного!',
  ConfigApplyRemoteBooking: 'Конфигурация применяется к модулю удаленного бронирования',
  AssociatedWarehouseSupplier: 'Связать поставщика склада',
  WarehouseNameCustomsBrokeDestinationAgent: 'Выберите элемент связанной конфигурации (название склада, таможенное оформление, агент порта назначения)',
  RelatedCustomsBroker: 'Связать таможенного брокера',
  RelatedDestinationAgent: 'Связать агента порта назначения',
  AssociatedWarehouseName: 'Связать название склада',
  PortCodeRepeat: 'Для порта {0} уже есть соответствующие настройки, не дублируйте.',
  RegionCodeRepeat: 'Для маршрута {0} уже есть соответствующие настройки, не дублируйте.',
  DesignatedCargoControlRange: 'Область контроля назначенных грузов:',
  RangeOfSelfPickupControl: 'Область контроля самостоятельно привлеченных грузов:',
  WarningConfiguration: 'Настройка предупреждений:',
  AccountsReceivableSettlementUnits: 'Все подразделения для расчета подлежащих оплате сборов',
  DeletePrompt: 'Подтверждаете удаление этой учетной записи? Уже сообщили в Cloudpawn о ее аннулировании?',
  EditUser: 'Редактировать пользователя',
  NewUser: 'Добавить пользователя',
  Password: 'Пароль',
  CustomerName: 'Название клиента',
  AccountMaintenance: 'Обслуживание учетной записи API',
  Unmaintained: 'Вы не предоставили логин и пароль для подписки на данные порта. Обратитесь в службу поддержки.',
  PortNotNull: 'Порт не может быть пустым',
  CustomerNotNull: 'Название клиента не может быть пустым',
  AccountNumberNotNull: 'Логин не может быть пустым',
  PasswordNotNull: 'Пароль не может быть пустым',
  CustomIdNotNull: 'customId не может быть пустым',
  PartnerWarehouseCode: 'Код складского номера партнера',
  PartnerWarehouseCodeTip: 'Когда в документах указаны грузоотправитель, агент по грузу и агент в порту назначения, можно установить приоритет выбора складского номера.',
  MailServer: 'Почтовый сервер',
  MailServerConfigTip: 'Сначала необходимо настроить и активировать корпоративную почту в [Сервисе конфигурации push-уведомлений].',
  PushConfigServiceCompanyEmail: 'Сначала настройте корпоративную почту в сервисе конфигурации рассылки и активируйте ее',
  PushConfigServicePersonalEmail: 'Выберите должность или личную почту сотрудника. Перед использованием необходимо настроить личную почту и включить ее',
  SelectSendEmail: 'Выбрать почту для отправки',
  Assigner: 'Назначенное лицо',
  ConfigEmailForNode: 'Настройте способ отправки почты для этого узла',
  MultipleTriggers: 'Многократное срабатывание',
  IsMultipleTriggers: 'Многократное срабатывание?',
  AllowTriggeringAgainValueChange: 'Повторное срабатывание при изменении значения поля',
  OnlyEntityCodeSupportTrigger: 'Многократное срабатывание поддерживается только для полей типа дата и строка с кодами Job/AirExportJob/AirlmportJob/IntegratedJob/SeaExportJob/Sealmportjob. Уточните у разработчиков!',
  TriggerTypeChangePushMsg: 'Повторная отправка сообщения при изменении значения триггера',
  CheckBaseLabel: 'Рассылка только контактам, указанным в документах',
  PushExternalInterfaces: 'Отправка во внешний API',
  TriggerInternalEvent: 'Активация внутреннего события',
  TriggerTypeChangePushInterface: 'Повторная отправка в API при изменении значения триггера',
  XhqBillDataUpdate: 'Обновление данных коносамента Signal',
  msdBillDataUpdate: 'API отправки данных счёта MSD',
  MsdApiLog: 'Журнал API MSD',
  canPushPreConfiguration: 'Поддержка推送 предварительной настройки',
  pushPreConfiguredInformation: 'Отправить предварительно настроенную информацию',
  pushMasterData: 'Отправить все данные текущего основного коносамента как предварительные настройки. После проверки нажмите "Подтвердить"',
  AgainPushTitleDisplay: 'В теме повторного письма будут отражены изменения. Например: "Бронирование [Судно/рейс] Было: SITC → Стало: LECANGS; Было: V.088W → Стало: 0XSJXS"',
  CheckRuleToAllBranch: 'Правила проверки действуют для всех филиалов',
  CustomDescription: 'Пользовательское описание',
  OnlyPositiveFeePermission: 'Нет прав на операцию. Можно добавлять только положительные суммы.',
  PleaseSelectOpBranch: 'Выберите филиал для операции!',
  OpOfficeChangeUpdateData: 'Филиал изменен. Обновить соответствующих сотрудников?',
  WarehouseChangeUpdateData: 'Филиал изменен. Обновить соответствующий склад/таможенного брокера/агента в порту назначения?',
  ClassifyName: 'Название категории',
  Sort: 'Сор.',
  ClassifyMsgNameEmpty: 'Название категории обязательно',
  ClassifyMsgSortEmpty: 'Сортировка обязательна',
  ClassifyMsgNameRepeat: 'Названия категорий не должны повторяться',
  ClassifyMsgSortRepeat: 'Номера сортировки не должны повторяться',
  ConfirmDeletionOfClassifyMsg: 'Удалить эту категорию сообщений? Будут удалены все языковые версии (кит./англ./яп.)!',
  ClassifyMsgDeletedTips: 'В этой категории есть уведомления - удаление невозможно!',
  MsgTitle: 'Заголовок сообщения',
  Content: 'Текст сообщения',
  ConfirmDeletionOfBellMsg: 'Удалить это уведомление? Будут удалены все языковые версии (кит./англ./яп.)!',
  BellMsgTitleEmpty: 'Заголовок сообщения обязателен',
  BellMsgCodeEmpty: 'Код обязателен',
  BellMsgContentEmpty: 'Текст сообщения обязателен',
  BellMsgTitleRepeat: 'Заголовок сообщения не должен повторяться',
  BellMsgCodeRepeat: 'Код не должен повторяться',
  BellMsgContentRepeat: 'Текст сообщения не должен повторяться',
  Language: 'Язык',
  Link: 'Адрес перехода',
  LinkTip: 'Маршрут перехода используется для перехода сообщения в соответствующий интерфейс операций. Перед заполнением согласуйте с разработчиками!',
  BellSubscriptionTitle: 'Настройки подписки на сообщения',
  BellSubscriptionConf: 'Подписка на уведомления',
  BellSubscribed: 'Подписано',
  BellUnSubscribed: 'Не подписано',
  MessageConfig: 'Настройки сообщений',
  WoBaoIntelligentAssistant: 'Умный помощник Wobao',
  WoBaoSubscriptionTip: 'Умный помощник Wobao будет напоминать на странице о непрочитанных сообщениях за сегодня',
  AllMessage: 'Все сообщения',
  TodayUnReadMsg: 'Непрочитанные сообщения за сегодня',
  ViewHQMapping: 'Просмотр HQ-отображения',
  BranchNotMatchNotOperate: 'Не относится к данным этого филиала, операция невозможна',
  UsersAlertNotifyAfterUsingXX: 'Пользователь может настроить предупреждение после использования XX%.',
  UsersAlertNotifyBeforeExpireDate: 'Пользователь может настроить предупреждение за XX дней до истечения срока.',
  UnloadingEortEnName: 'Английское название порта выгрузки',
  OriginPortEnName: 'Английское название порта отправления',
  MatchingCriteriaSelection: 'Выбор условий соответствия',
  PresetValueConfiguration: 'Настройка предустановленных значений',
  MatchingCriteriaSelectionTip: 'Используется для соответствия в бизнес-документах. При соответствии условиям происходит автоматическое заполнение предустановленных значений.',
  PresetValueConfigurationTip: 'Для морского экспорта расчет дней упреждения основан на ETD. Автоматически компенсируются выходные дни. При значении 0 дни не рассчитываются автоматически.',
  PleaseSelectDeparturePort: 'Выберите порт отправления',
  PleaseSelectUnloadingPort: 'Выберите порт выгрузки',
  PleaseSelectCarrier: 'Выберите перевозчика',
  PortRequirementBillRequirements: 'Требования порта (требования коносамента)',
  PleaseSaveCurrentDataFirst: 'Сначала сохраните текущие данные',
  RelatedInstructionsAttachments: 'Прилагаемые пояснительные документы',
  PortRequirementsRelatedDocuments: 'Документы, связанные с требованиями порта',
  NoRelevantDocumentsAvailable: 'Нет связанных документов',
  DefaultConfigurationNotes: 'Примечание к предустановленной конфигурации',
  PleaseSelectMatchingItem: 'Выберите элемент соответствия',
  CalculateDateIncludeETDTheDay: 'Расчет упреждения включает день ETD',
  SetLeadTimeBasedOnETDTime: 'Настройка упреждения на основе времени ETD',
  PleaseSetPreset: 'Установите предустановленный элемент',
  WoBaoSubscribed: 'Включено',
  WoBaoUnSubscribed: 'Выключено',
  CalculateIncludeEtdIsWeekend: 'Расчет упреждения включает выходные дни ETD',
  PositionAssociatedRoutePortConfig: 'Предустановленная конфигурация связи сотрудников с маршрутами/портами',
  PleaseSelectLoadingPort: 'Выберите порт погрузки',
  PleaseSelectOriginatingStation: 'Выберите станцию отправления',
  PleaseSelectDestinationStation: 'Выберите станцию назначения',
  PositionCannotDuplicated: 'Должность не должна повторяться',
  UserHasRepeatConfigData: 'У этого пользователя уже есть повторяющиеся данные конфигурации!',
  UserRoleDefaultRepeat: 'Другие сотрудники уже настроили значения по умолчанию для этих условий. Подтвердите изменение?',
  ChartSource: 'Источник диаграммы',
  EnterChartSource: 'Выберите источник диаграммы',
  ToDoNodeRuleSettings: 'Настройка правил узлов задач',
  ServiceScenarioApplication: 'Специфические бизнес-правила',
  SettingApplicationScenarios: 'Настройка бизнес-правил',
  OperationButtonSettings: 'Настройка кнопок действий',
  ButtonName: 'Название кнопки',
  MainNotToDoTask: 'Основные документы не считаются задачами (сценарий консолидации)',
  SpecifyRole: 'Назначенные роли',
  CheckPrivilegePersonLabel: 'Ограничить ли роли без прав на тип возможность изменения типа файла',
  SetExclusionOffices: 'Настройка исключений для филиалов',
  AccountsReceivable: 'Дебиторская задолженность',
  Just: 'И',
  NotEntityCompany: 'Неюридическое лицо',
  NotEntityCompanyTip: 'При статистике определенных финансовых отчетов необходимо отметить этот флаг.',
  Marked: 'Маркировка',
  NotSetDefaultValueMultiPosition: 'При совпадении условий с несколькими сотрудниками значение по умолчанию не подставляется, требуется ручной выбор!',
  AvailableOfficeOverMaxLimit: 'Достигнут лимит доступных филиалов. Для увеличения количества свяжитесь с вашим продавцом или службой поддержки.',
  AvailableUserOverMaxLimit: 'Достигнут лимит доступных пользователей. Для увеличения количества свяжитесь с вашим продавцом или службой поддержки.',
  BranchCountExpireLimitUse: 'Уважаемый пользователь, срок действия вашего расширения для филиалов истек.<br>Продлите подписку для продолжения использования, свяжитесь с продавцом или службой поддержки.<br><div style="margin-top: 5px;">Текущие филиалы будут ограничены в доступе, данные сохранятся. После продления доступ возобновится.</div>',
  UserCountExpireLimitUse: 'Уважаемый пользователь, срок действия вашего расширения пользователей истек.<br>Продлите подписку для продолжения использования, свяжитесь с продавцом или службой поддержки.<br><div style="margin-top: 5px;">Текущие пользователи будут деактивированы, данные сохранятся. После продления их можно будет активировать.</div>',
  UserCountExpireLimitAdmin: 'Уважаемый пользователь, срок действия вашего расширения пользователей истек.<br>Продлите подписку для продолжения использования, свяжитесь с продавцом или службой поддержки.<br><div style="margin-top: 5px;">Текущие пользователи (кроме системных администраторов) будут деактивированы, данные сохранятся. После продления их можно будет активировать.</div>',
  OpenConfig: 'Активировать настройку',
  SendType: 'Режим отправки',
  Key: 'Ключ',
  UserPwd: 'Пароль учетной записи',
  OpenConfigTip: 'После активации шаблон будет отправляться согласно настроенному {0}',
  NotEmptyTips: 'Синие поля обязательны для заполнения!',
  MustBeNumericType: '{0} должен быть числового типа',
  MainTicket: 'ОСД',
  SlaveTicket: 'ВД',
  Alias: 'ПН',
  SetAlias: 'Настройка псевдонима',
  AliasOnlyHQ: 'Настройка псевдонимов осуществляется только на уровне HQ',
  HideCategoryAllLanguage: 'Скрыть эту категорию (применяется ко всем языковым версиям)',
  FieldDisplayHideForbid: 'Если в категории есть поля с видимым статусом, скрытие запрещено!',
  SetBlockWidth: 'Установить ширину блока',
  SettableRange300400: 'Доступный диапазон: 300-400',
  HQSavePrompt: 'Подсказка при сохранении HQ',
  BranchSavePrompt: 'Подсказка при сохранении филиала',
  OnlyDisplayMandatoryRule: 'Только настройка видимости и обязательности полей, без перезаписи порядка полей в пользовательских страницах филиалов и сотрудников!',
  DisplayMandatorySort: 'Настройка видимости и обязательности полей с сбросом порядка полей в пользовательских страницах филиалов и сотрудников по правилам HQ!',
  AdjustOrderConfig: 'Это приведет к изменению порядка интерфейса всех филиалов и сотрудников согласно настройкам HQ!',
  OfficeOnlyDisplayMandatoryRule: 'Только настройка видимости и обязательности полей, без перезаписи порядка полей в пользовательских страницах сотрудников!',
  OfficeDisplayMandatorySort: 'Настройка видимости и обязательности полей с сбросом порядка полей в пользовательских страницах сотрудников по правилам филиала!',
  OfficeAdjustOrderConfig: 'Это приведет к изменению порядка интерфейса сотрудников согласно настройкам филиала!',
  ApplyHQSetting: 'Подтвердить применение настроек головного офиса?',
  ResetCustomSetConfirm: 'Подтвердить сброс пользовательских настроек этой вкладки? Это действие необратимо, подтвердите!',
  HQSettingNotEditAlias: 'При применении настроек HQ филиалы нельзя редактировать. Настройка псевдонимов осуществляется только на уровне HQ.',
  NonLoginUser: 'Пользователи без входа в систему',
  ValidUserNotNeedLogin: 'Действующие пользователи, не требующие входа в систему',
  NotLoginUserContactAdmin: 'Системный администратор назначил вас как пользователя без входа в систему. Для доступа обратитесь к администратору и войдите заново.',
  FinanceExpireLimitUse: 'Уважаемый пользователь, срок действия вашего модуля финансового управления истек.<br>Продлите подписку для продолжения использования, свяжитесь с продавцом или службой поддержки.<br><div style="margin-top: 5px;">Модуль будет ограничен в доступе, данные сохранятся. После продления доступ возобновится.</div>',
  EdiExpireLimitUse: 'Уважаемый пользователь, срок действия вашего EDI-интерфейса бронирования истек.<br>Продлите подписку для продолжения использования, свяжитесь с продавцом или службой поддержки.',
  TaxExpireLimitUse: 'Уважаемый пользователь, у вас не подключена услуга налогового контроля, или срок действия приобретенной услуги истек.<br>Пожалуйста, продлите подписку для дальнейшего использования. Вы можете связаться с вашим продавцом или службой поддержки.',
  EntrustPageTab: 'Вкладка Доверенность',
  ExportEntrustPageTab: 'Вкладка Экспортная доверенность',
  ImportEntrustPageTab: 'Вкладка Импортная доверенность',
  AttachmentRuleConfig: 'Настройка правил вложений',
  BusinessOrdersAttachments: 'При наличии формальной раздельной накладной в бизнесе, вложение извлекает формальную раздельную накладную',
  SendPackageProxyFiles: 'История файлов - отправка комплекта документов агенту',
  BillNotStartNoneFile: 'Когда статус коносамента HBL не начат или ожидает подтверждения, не извлекаются никакие файлы коносамента (включая образцы)',
  LockAfterSend: 'Блокировка после отправки:',
  SendLockSlaveHblAndVirtualBill: 'После отправки блокируются вкладки HBL и формальной раздельной накладной для квитанции (включая разделение/объединение накладных)',
  SendLockExchangeAgentHblAndVirtualBill: 'После отправки блокируются вкладки HBL и формальной раздельной накладной для соответствующего агента по замене документов (включая разделение/объединение накладных)',
  AutoPrintManifestAfterAllHblConfirm: 'Автоматическая печать файла MANIFEST только после подтверждения статуса всех коносаментов HBL (включая разделение HBL)',
  BusinessDataNotUpdate: 'При обновлении бизнес-данных персонал не обновляется автоматически',
  AutoPrintRule: 'Правила автоматической печати',
  EmailAttachRule: 'Правила извлечения вложений электронной почты',
  FormalDivisionRule: 'Правила формальной раздельной накладной',
  BusinessIfVirtualBillOnlyAttachment: 'При наличии формальной раздельной накладной в бизнесе, вложение извлекает только файл формальной раздельной накладной',
  SetFileSyncRule: 'Настройка правил синхронизации файлов',
  BusinessModel: 'Бизнес-модель:',
  SyncDirection: 'Направление синхронизации:',
  SyncCondition: 'Условие синхронизации',
  SyncFileToApprovedDoc: 'Файлы могут быть синхронизированы с утверждёнными документами',
  DeleteFile: 'Удаление файлов:',
  SyncMode: 'Режим синхронизации:',
  CrossDelegation: 'Перекрестное доверие',
  PrincipalOperator: 'Доверитель -> Оператор',
  OperatorClient: 'Оператор -> Доверитель',
  SyncFileDeletion: 'Синхронное удаление файлов',
  NotDeleteRelateFile: 'Не удалять файлы другой стороны',
  ManualSync: 'Ручная синхронизация',
  AutoSync: 'Автоматическая синхронизация',
  ExportToImport: 'Экспорт в импорт',
  ExporterImporter: 'Экспортер -> Импортер',
  ImporterExporter: 'Импортер -> Экспортер',
  BbSendDestinationPortAgent: 'Отправка документов агенту порта назначения для консолидации груза',
  ChargeSyncAuditPass: 'Синхронизация расходов-проверка утверждена',
  ChargeSyncAuditNotPass: 'Синхронизация расходов-проверка не прошла',
  ChargeSyncRecallApplyCharge: 'Синхронизация затрат-снятие обвинений',
  SendEmailByPositionPersonnel: 'Почта передается персоналу, назначающему место отправителя',
  AttachmentItems: 'Пункты вложений',
  PleaseSetAttach: 'Пожалуйста, сначала установите типы файлов для пунктов вложений!',
  SendLockHblAndVirtualBill: 'После отправки блокируются вкладки HBL и формальной раздельной накладной для бизнеса (включая разделение/объединение накладных)',
  AirOperationTAB: 'Вкладка "Авиаперевозки"',
  CurrentPageNewFieldTip: 'В текущей вкладке есть новые поля. Пожалуйста, нажмите "Редактировать", чтобы добавить поля.',
  SystemAddedItem: 'Новые поля системы',
  DragTheBlockUse: 'Пожалуйста, перетащите поле в соответствующий блок классификации для использования',
  CustomTemplateMustSelect: 'Для имени пользовательского шаблона необходимо выбрать информацию',
  VirtualBillHBLNO: 'Формальная раздельная накладная HB/L NO',
  TemplateRemarks: 'Примечание к шаблону',
  AutomPrintDefaultFileType: 'Тип файла по умолчанию для автоматической печати',
  PopupMode: 'Режим всплывающего окна',
  DisplayWhenThereIsValidation: 'Показывать всплывающее окно с информацией о проверке только при наличии ошибок',
  TheBeAppliedToOffices: 'Режим всплывающего окна будет применен ко всем филиалам',
  VerificationNodeCannotBeEmpty: '【Узел проверки】 не может быть пустым',
  VerificationModeCannotBeEmpty: '【Режим проверки】 не может быть пустым',
  CustomerOfLadingOptionIssue: 'Самостоятельное оформление клиентом (коносамент с отметкой "Самостоятельное оформление клиентом")',
  WhenLadingHasBeenDocuments: 'При наличии документов, оформленных клиентом, и подтверждённого или выпущенного коносамента, извлекать документы клиента',
  WhenIsNeitherConfirmedExtracted: 'При наличии документов, оформленных клиентом, но неподтверждённого и невыпущенного коносамента, не извлекать документы клиента',
  WhenOfLadingHasSample: 'При отсутствии документов, оформленных клиентом, и подтверждённого, но невыпущенного коносамента, автоматически печатать образец',
  ApplicationModule: 'Модуль приложения',
  UICustomisation: 'Настройка интерфейса (UI)',
  SOPPanel: 'Панель SOP',
  FileHistoryTab: 'Вкладка истории документов',
  ViewOpInstruction: 'Просмотр операционных инструкций',
  SetOpInstruction: 'Настройка операционных инструкций',
  HeadquartersSetupForCommandApplications: 'Настройка применения инструкций головной компанией',
  SetCommandParameters: 'Настройка параметров инструкций',
  DisplayRuleSettings: 'Настройка правил отображения',
  PleaseCommandForAScenario: 'Пожалуйста, настройте операционную инструкцию.',
  CommandParameters: 'Параметры инструкции',
  SceneRules: 'Правила сценария',
  SceneParameters: 'Параметры сценария',
  CommandApplication: 'Применение инструкции',
  TheAsTheOceanConfiguration: 'Псевдоним поля предварительной проверки бронирования совпадает с настройками морской перевозки, независимая настройка не поддерживается!',
  TheAsThoseForConfiguration: 'Псевдонимы полей для поручения бронирования морских перевозок совпадают с настройками бронирования морских перевозок и не поддерживают независимую настройку!',
  TheAsTheAirConfiguration: 'Поле псевдонима для бронирования воздушных перевозок такое же, как настройки бронирования воздушных перевозок, и не поддерживает независимую настройку!',
  TheThoseInTheConfiguration: 'Псевдонимы полей для заказа перевозки по железной дороге совпадают с настройками операций по железной дороге и не поддерживают независимую настройку!',
  TheOrderInTheConfiguration: 'Псевдоним поля предварительной проверки заказа соответствует настройкам бронирования авиаперевозок и не поддерживает независимую конфигурацию!',
  TriggerNodeStatesupConfigured: 'Запуск отката состояния других узлов (максимум 5 настроек)',
  RollbackBeSetOnlyStartedAbnormal: 'Возврат к состоянию других узлов можно установить только в том случае, если [Тип состояния] — [Не начато]/[Аномалия].',
  PleaseNodeThatNeedsTriggered: 'Пожалуйста, установите узел отката, который нужно активировать',
  TheNodeCannotBeEmpty: 'Узел не может быть пустым',
  TheStatusCannotBeEmpty: 'Статус узла не может быть пустым',
  AllowStatusToTriggerRollback: 'Разрешить состоянию узла запускать откат',
  SOPRestrictionsForBusinessDocuments: 'Ограничения соответствия шаблонов SOP для деловых документов',
  OnlyForTheBranchTemplate: 'Только операции приложения, настроенные для филиала и шаблона HQ',
  OnlyOperationDepartmentAndTemplate: 'Только заданные отдел операций приложения и шаблон HQ',
  TabSettings: 'Настройки вкладок',
  StandardFeesTab: 'Вкладка стандартных расходов',
  HideStandardFeeTab: 'Скрыть вкладку стандартных сборов',
  DisplayAsASeparateTab: 'Отображать как отдельную вкладку',
  DropdownBoxValueDisplay: 'Отображение значения выпадающего списка:',
  DisplayRecentlyUsed50Values: 'Показать последние 50 используемых значений данных',
  DisplayOrderLogic: 'Логика порядка отображения:',
  TheFirstValueTheSequentially: 'Последнее сохранённое значение будет отображаться первым, предыдущее — вторым и так далее по порядку.',
  InstructionPermissions: 'Права на команды',
  AllPositions2: 'Все должности',
  PleaseAPositionOrPersonnel: 'Выберите должность или персонал',
  SalesModule: 'Модуль продаж',
  SalesInquiry: 'Запрос по продажам',
  DisplaySettings: 'Настройки отображения',
  ApplicationSettings: 'Настройки приложения',
  ReadAndWriteSettings: 'Настройки чтения и записи',
  CanEditable: 'Можно редактировать',
  VisibleToDesignatedPersonnel: 'Видимо для указанного персонала:',
  FieldPermissionSettings: 'Настройки прав доступа к полям',
  SalesInquiryApplication: 'Приложение для запроса продаж',
  SalesTheCustomTabUI: 'Поиск продаж позволяет отображать пользовательскую вкладку этого интерфейса',
  DisplayCargoPackingInformation: 'Показать информацию о грузе в упаковке',
  ControlPropertyConfiguration: 'Настройка свойств элемента управления',
  WhenMainTicketDisplayMode: 'Когда документ по делам является основным билетом, отображается режим упаковки основного билета.',
  UpdatePortDataButton: 'Кнопка обновления данных порта',
  UIFieldConfiguration: 'Конфигурация полей пользовательского интерфейса',
  AutomatedExecution: 'Автоматическое выполнение',
  InvokeAutomatedExecution: 'Вызвать автоматическое выполнение',
  SOPStatusTrigger: 'Триггер состояния ПСО',
  TriggerBasedOnFieldValue: 'Срабатывание на основе значения поля',
  DocumentInfo: 'Информация о документе',
  DocumentTemplate: 'Шаблон документа',
  LocalizedTemplateName: 'Локализованное название шаблона',
  TemplateId: 'ID шаблона',
  TemplateStatus: 'Статус шаблона',
  TemplateType: 'Тип шаблона',
  TemplateDescription: 'Описание шаблона',
  LocalizedTemplateDescription: 'Локализованное описание шаблона',
  ApplicableCarrier: 'Применимый перевозчик',
  ApplicableSeaport: 'Применимый порт',
  PleaseEnterLocalTemplateName: 'Пожалуйста, введите название локального шаблона',
  TemplateEnabledPrompt: '【{0}】 - 【{1}】 файл корректен. После включения он может быть использован пользователями в бизнес-операциях.',
  TemplateDisabledPrompt: '【{0}】 - 【{1}】 после отключения не будет доступен для поиска или использования пользователями в бизнес-операциях.',
  TemplateDeletedPrompt: 'Пожалуйста, подтвердите, удален ли 【{0}】 - 【{1}】.',
  TriggeredToSpecificBusinessRules: 'Срабатывает в соответствии с определенными бизнес-правилами',
  InvoiceInquiryTab: 'Вкладка поиска счетов',
  SetFieldValueSynchronization: 'Настройка синхронизации значений полей',
  SourceTab: 'Вкладка источника',
  SourceField: 'Поле источника',
  WriteTab: 'Вкладка записи',
  WriteField: 'Запись в поле',
  SyncOnlyAtCreation: 'Синхронизация только при создании',
  SynchronizedReceiptWithMainTicket: 'Синхронизированный чек с основным билетом',
  AreWantToDeleteData: 'Вы уверены, что хотите удалить выбранные данные?',
  TheFieldCannotBeEmpty: 'Поле 【{0}】 не может быть пустым.',
  ConfirmFieldValueSynchronizationConfiguration: 'Подтвердить настройку синхронизации значений полей?',
  ShippingInformationNonMainInvoice: 'Информация о упаковке — неосновной счет-фактура',
  ConfirmBatchModification: 'Вы уверены, что хотите подтвердить пакетное изменение?',
  PleaseSelectFillModeAndForm: 'Пожалуйста, выберите режим заполнения и форму!',
  FillFormCannotBeEmpty: 'Форма заполнения не может быть пустой!',
  BatchModificationPrompt: 'Подсказка пакетного изменения',
  ConfirmBatchModification: 'Вы уверены, что хотите выполнить пакетное изменение? Эта операция изменит все выбранные задачи в пакетном режиме.',
  BatchModificationConfirm: 'Подтверждение пакетного изменения',
  TemplateApplicationSettings: 'Настройки применения шаблона',
  MatchingSettings: 'Настройки соответствия',
  ManualSOPTemplatesIsAllowed: 'Ручная замена шаблонов ПП не разрешена.',
  DoTemplateIsAutomaticallyTemplate: 'Не отображать подсказку при автоматическом сопоставлении шаблона с новым шаблоном.',
  ContainerMaxNumTip: 'Количество коробок не может превышать [{0}] штук. При необходимости превышения этого лимита свяжитесь с службой поддержки клиентов для корректировки порогового значения параметра [ContainerMaxNum].',
  BatchOperationSettings: 'Настройки пакетной операции',
  BatchOperationsSupported: 'Поддержка пакетных операций',
  BulkOperationPrompt: 'Подсказка пакетной операции',
  PleaseSelectRailwayExportServices: 'Пожалуйста, выберите услуги по экспорту железнодорожных перевозок',
  PleaseSelectRailwayImportBusiness: 'Пожалуйста, выберите железнодорожную импортную деятельность',
  BatchAllowedPleaseSelectRecord: 'Массовые операции недоступны. Пожалуйста, выберите одну запись.',
  AreWantToPerformOperation: 'Вы уверены, что хотите выполнить пакетную операцию?',
  NonNotSupportCrossTenants: 'Компании, не входящие в группу, не поддерживают перекрестное поручение между арендаторами.',
  NoBusinessCanBeEntrusted: 'Нет возможности поручить дела',
  PleaseSelect0: 'Пожалуйста, выберите {0}',
  ShippingInformationMasterBill: 'Информация о упаковке - Мастер-билл',
  HideDefaultButton: 'Скрыть кнопку по умолчанию',
  AdditionalReceivables: 'Дополнительные дебиторские задолженности',
  AdditionalPayable: 'Дополнительная сумма к оплате'
}
